import type {
  ITableCell,
  ITableCellContentAppliableSettings,
} from "@library-elements/table";
import { tableApplyFroalaContentSettings } from "./table-apply-froala-content-settings";

// Seed with a non-empty text node so the formatter has something to wrap; the
// placeholder is replaced by renderCalcResult at render time.
const seedCalcWrapper = (): string => "<p>VALUE</p>";

/**
 * Apply a formatting bag to a calc cell via the same rich-text path as a text
 * cell, storing the result in `cell.calcFormatHtml` (never `cell.content`).
 */
export const formatCalcCell = (
  cell: ITableCell,
  obj: ITableCellContentAppliableSettings,
): void => {
  if (obj.clearFormatting) {
    cell.calcFormatHtml = undefined;
    return;
  }

  const shim = {
    content: cell.calcFormatHtml ?? seedCalcWrapper(),
  } as ITableCell;
  tableApplyFroalaContentSettings({ ...obj, cell: shim });
  cell.calcFormatHtml = shim.content;
};
